import React from "react";
import { useTranslation } from "react-i18next";
import LegalLayout from "./LegalLayout";

/**
 * /legal/terms — public placeholder page. Full Terms of Service will be
 * published before commercial launch. i18n scope: `legal.terms`.
 */
export default function Terms() {
  const { t } = useTranslation("legal");
  return (
    <LegalLayout
      testId="legal-terms-page"
      metaTitle={t("terms.meta_title")}
      kicker={t("terms.kicker")}
      pageTitle={t("terms.page_title")}
      body={t("terms.body")}
      backHomeLabel={t("terms.back_home")}
      contactLabel={t("common.contact_us")}
      contactEmail={t("common.contact_email")}
    />
  );
}
